import Promotedetails from '@/components/Promotedetails/index'
const Logspage = () => {
    const element = (<Promotedetails />)
    return element
}
export default Logspage